import { z } from 'zod';
import isNumeric from 'validator/lib/isNumeric';

// custom validator for numeric strings (empty string is valid)
export const numericString = z
  .string()
  .trim()
  .refine((val) => val === '' || isNumeric(val), {
    message: 'Must be a number',
  })
  .default('');
